module.exports = __webpack_public_path__ + "static/media/welcome_image_mobile.718575c5.png";